// src/components/VideoPlayer.jsx
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import BackHome from "../components/studio/BackHome";
import CategoryList from "../components/studio/CategoryList";
import FilmGrid from "../components/studio/FilmGrid";
import VideoPlayer from "../components/studio/VideoPlayer";
import { supabase } from "../services/supabase";
function Studio() {
  const { id } = useParams();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [films, setFilms] = useState([]);
  const [currentFilm, setCurrentFilm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalFilms, setTotalFilms] = useState(0);

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      fetchFilms();
    }
  }, [selectedCategory]);

  const handleVideoEnd = useCallback(() => {
    // Tìm index của video hiện tại
    const currentIndex = films.findIndex((film) => film.id === currentFilm?.id);

    // Tính toán index của video tiếp theo
    const nextIndex = currentIndex + 1;

    // Kiểm tra và set video tiếp theo
    if (nextIndex < films.length) {
      const nextVideo = films[nextIndex];
      setCurrentFilm(nextVideo);
    }
  }, [films, currentFilm]);

  const fetchCategories = async () => {
    const { data, error } = await supabase
      .from("categories")
      .select("*")
      .eq("parentid", parseInt(id));
    if (data) setCategories(data);
  };

  const fetchFilms = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("media")
      .select("*")
      .eq("categoryid", selectedCategory.id)
      .order("id", { ascending: true });

    if (data) {
      setFilms(data);
      setTotalFilms(data.length); // Cập nhật tổng số phim
    }
    setLoading(false);
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleFilmSelect = (film) => {
    setCurrentFilm(film);
  };
  return (
    <>
      <div className="min-h-screen p-8">
        <div className="container mx-auto">
          <BackHome />
          <div className="w-full flex">
            <div className="w-4/6">
              {currentFilm && (
                <VideoPlayer film={currentFilm} onVideoEnd={handleVideoEnd} />
              )}
            </div>
            <div className="w-2/6 pl-4">
              {categories && (
                <CategoryList
                  categories={categories}
                  selectedCategory={selectedCategory}
                  onSelectCategory={handleCategorySelect}
                />
              )}
              {loading ? (
                <div className="flex justify-center items-center h-64">
                  <ClipLoader size={50} color={"#e74c3c"} loading={loading} />
                </div>
              ) : (
                films && (
                  <FilmGrid films={films} onSelectFilm={handleFilmSelect} />
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Studio;
